<template>
  <div id="cardArea">
    <div class=custom>
      <icon-base icon-name="phone"><icon-phone /></icon-base>
      <div>Dúvidas? Fale Conosco!</div>
    </div>
    <div id=carrinho :title="mensagem">
      <icon-base icon-name="cart"><icon-cart /></icon-base>
      {{quantidade}}
    </div>
  </div>
</template>

<script>
  import IconBase from './IconBase.vue'
  import IconCart from './icons/IconCart.vue'
  import IconPhone from './icons/IconPhone'

  const components = {
    IconBase,
    IconCart,
    IconPhone
  }

  const computed = {
    quantidade() {
      return this.$store.getters.quantidade;
    },
    mensagem() {
      return this.$store.getters.mensagem;
    }
  }

  export default {
    computed,
    components
  }
</script>

<style scoped>
  #cardArea {
    display: flex;
    justify-content: space-between;
  }
  .custom {
    display: flex;
    justify-content: space-between;
  }
  #carrinho {
    cursor: pointer;
  }
</style>